'use strict'; //

exports.__esModule = true;
exports.default = void 0;

var _jquery = require("jquery");

var _validator = _interopRequireDefault(require("./validator"));

var _tools = require("../libs/tools");

var _get = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//

/**
 *
 * @param value
 * @returns {boolean}
 * @private
 */
var _toBoolean = function _toBoolean(value) {
  return ['yes', 'on', '1', 'true', true].indexOf(value) > -1;
};
/**
 *
 * @param value
 * @param item
 * @returns {*}
 * @private
 */


var _parseValue = function _parseValue(value, item) {
  if (item.int || item.type === 'int') {
    return parseInt(value);
  } else if (item.float || item.type === 'float') {
    return parseFloat(value);
  } else if (item.boolean || item.type === 'boolean') {
    return _toBoolean(value);
  }

  return value;
};
/**
 *
 * @param type
 * @param args
 * @param rules
 * @returns {{fn, args: *}}
 * @private
 */


var _getValidateRuleFnAndArgs = function _getValidateRuleFnAndArgs(type, args, rules, msgs) {
  var fn = _validator.default[type];

  if (!(0, _tools.is_function)(fn)) {
    console.error((msgs['CONFIG_NOT_FUNCTION'] || 'CONFIG_NOT_FUNCTION') + (" " + type + " type")); // throw new Error((msgs['CONFIG_NOT_FUNCTION'] || 'CONFIG_NOT_FUNCTION') + ` ${type} type`);

    return;
  }

  if ((0, _tools.is_bool)(args)) {
    args = [];
  } else if (!(0, _tools.is_array)(args)) {
    args = [args];
  }

  var parseArgs = _validator.default["_" + type]; //parse args

  if ((0, _tools.is_function)(parseArgs)) {
    args = parseArgs(args, rules);
  }

  return {
    fn: fn,
    args: args
  };
};
/**
 * get item value
 * @param  {Object} item   []
 * @param  {Object} values []
 * @return {Mixed}        []
 */


var _getItemValue = function _getItemValue(item, values, parse) {
  //get item value
  //avoid default is undefined, but check type is string
  var itemValue = item.value; //trim value

  if (item.trim && itemValue && itemValue.trim) {
    itemValue = itemValue.trim();
  }

  var _default = item.default;

  if (!itemValue && (0, _tools.empty)(_default)) {
    itemValue = item.default;
  }

  if ((0, _tools.is_function)(itemValue)) {
    itemValue = itemValue.call(values);
  } //make data to array when type is array


  if (item.value && item.array && !(0, _tools.is_array)(item.value)) {
    if ((0, _tools.is_string)(itemValue)) {
      try {
        itemValue = JSON.parse(itemValue);
      } catch (e) {
        itemValue = itemValue.split(/\s*,\s*/);
      }
    } else {
      itemValue = [itemValue];
    }
  } //make data to object when type is object
  else if (item.value && item.object && (0, _tools.is_string)(itemValue)) {
    try {
      itemValue = JSON.parse(itemValue);
    } catch (e) {}
  } else if (item.boolean) {
    itemValue = _toBoolean(itemValue);
  } //parse value


  if (parse) {
    if (item.array) {
      itemValue = itemValue.map(function (it) {
        return _parseValue(it, item);
      });
    } else {
      itemValue = _parseValue(itemValue, item);
    }
  }

  return itemValue;
};
/**
 *
 * @param type
 * @param name
 * @param value
 * @param args
 * @param msgs
 * @returns {*}
 * @private
 */


var _getValidateErrorMsg = function _getValidateErrorMsg(type, name, value, args, msgs) {
  var key = "validate_" + type;
  var keyWithName = key + "_" + name;
  var msg = msgs[keyWithName];
  msg = msg || msgs[key] || key; // msg = msg || msgs['PARAMS_NOT_VALID'] || 'PARAMS_NOT_VALID';

  return msg.replace('{name}', name).replace('{value}', value).replace('{args}', args.join(','));
};
/**
 *
 * @param rules
 * @param msgs
 * @returns {{}}
 * @private
 */


var _exec = function _exec(rules, msgs) {
  if (msgs === void 0) {
    msgs = {};
  }

  var ret = {};

  var values = _getRuleValues(rules);

  var _loop = function _loop(name) {
    var item = rules[name];

    var itemValue = _getItemValue(item, values);

    var _loop2 = function _loop2(vtype) {
      if (vtype === 'value' || vtype === 'default' || vtype === 'trim') {
        return "continue";
      } //if has array rule, then foreach check value for every rule


      if (item.array && vtype !== 'array' && (0, _tools.is_array)(itemValue)) {
        var flag = itemValue.some(function (ivalue) {
          var _getValidateRuleFnAnd = _getValidateRuleFnAndArgs(vtype, item[vtype], rules, msgs),
              fn = _getValidateRuleFnAnd.fn,
              args = _getValidateRuleFnAnd.args;

          var result = fn.apply(void 0, [ivalue].concat(args));

          if (!result) {
            var msg = _getValidateErrorMsg(vtype, name, ivalue, args, msgs);

            ret[name] = msg;
            return true;
          }
        });

        if (flag) {
          return "break";
        }
      } else {
        var _getValidateRuleFnAnd2 = _getValidateRuleFnAndArgs(vtype, item[vtype], rules, msgs),
            fn = _getValidateRuleFnAnd2.fn,
            args = _getValidateRuleFnAnd2.args;

        var result = fn.apply(void 0, [itemValue].concat(args));

        if (!result) {
          var msg = _getValidateErrorMsg(vtype, name, itemValue, args, msgs);

          ret[name] = msg;
          return "break";
        }
      }
    };

    for (var vtype in item) {
      var _ret = _loop2(vtype);

      if (_ret === "continue") continue;
      if (_ret === "break") break;
    }
  };

  for (var name in rules) {
    _loop(name);
  }

  return ret;
};
/**
 *
 * @param data 验证规则
 * @param fromData 表单数据
 * @return {{}}
 * @private
 */


var _parseValidateData = function _parseValidateData(data, fromData) {
  if (data === void 0) {
    data = {};
  }

  if (fromData === void 0) {
    fromData = {};
  }

  var result = {}; // let allowTypes = ['boolean', 'int', 'float', 'string', 'array', 'object'];

  for (var name in data) {
    var itemData = data[name];

    if ((0, _tools.is_string)(itemData)) {
      itemData = _parse(itemData);
    } else {
      itemData = (0, _jquery.extend)({}, itemData);
    } // let method = this._getValidateItemMethod(itemData);
    // if (method === 'file') {
    //     itemData.object = true;
    // }
    // itemData._method = method;
    //ignore set itemData.value when aleady has it


    if (!('value' in itemData)) {
      // itemData.value = _getFormData(name, fromData);
      itemData.value = (0, _get.default)(fromData, name, undefined);
    } // let flag = allowTypes.some(item => {
    //     return item in itemData;
    // });
    //if (!flag) {
    //    itemData.string = true;
    //}


    result[name] = itemData;
  }

  return result;
};
/**
 *
 * @param name
 * @param fromData
 * @return {*}
 * @private
 */


var _getFormData = function _getFormData(name, fromData) {
  var ret = fromData;
  var names = name.split(".");

  for (var i in names) {
    if (ret[names[i]]) {
      ret = ret[names[i]];
    } else {
      return undefined;
    }
  }

  if ((0, _tools.is_string)(ret)) return ret;
  return undefined;
};
/**
 * merge clean rules(only value)
 * @param  {Object} rules []
 * @return {Object}       []
 */


var _mergeCleanRules = function _mergeCleanRules(rules, formData) {
  var listData = [formData]; //let methods = ['post', 'get'];

  listData.forEach(function (item, index) {
    for (var key in item) {
      if (!rules[key]) {
        rules[key] = {
          value: item[key] //_method: methods[index]

        };
      }
    }
  });
  return rules;
};
/**
 *
 * @param rule
 * @returns {{}}
 * @private
 */


var _parse = function _parse(rule) {
  var rules = rule.split('|');
  var ret = {};
  rules.forEach(function (item) {
    item = item.trim();

    if (!item) {
      return;
    }

    var pos = item.indexOf(':');

    if (pos > -1) {
      var name = item.substr(0, pos);
      var args = item.substr(pos + 1).trim();

      if (args[0] === '{' || args[0] === '[') {
        var value = new Function('', "return " + args)();
        args = name === 'default' ? value : [value];
      } else if (name !== 'default') {
        args = args.split(/\s*,\s*/);
      }

      ret[name] = args;
    } else {
      ret[item] = true;
    }
  });
  return ret;
};
/**
 * get all rule values, for default function to get value
 * @param  {Object} rules []
 * @return {Object}       []
 */


var _getRuleValues = function _getRuleValues(rules) {
  var ret = {};

  for (var name in rules) {
    ret[name] = rules[name].value;
  }

  return ret;
};
/**
 *
 * @param rules
 * @param formData
 * @param msg
 * @returns {*}
 * @private
 */


var _validate = function _validate(rules, formData, msg) {
  if ((0, _tools.empty)(rules)) {
    return true;
  }

  rules = _parseValidateData(rules, formData, msg);
  rules = _mergeCleanRules(rules, formData, msg);
  var methods = {};

  for (var name in rules) {
    methods[name] = rules[name]._method;
    delete rules[name]._method;
  }

  var ret = _exec(rules, msg);

  if (!(0, _tools.empty)(ret)) {
    return ret;
  } //set values
  // let values = _values(rules);
  // for (let name in values) {
  //     let method = methods[name];
  //     let value = values[name];
  //     if (value !== '' || (typeof value === 'number' && !isNaN(value))) {
  //         formData[name] = value;
  //     }
  // }


  return true;
};
/**
 *
 * @param rules
 * @returns {{}}
 * @private
 */


var _values = function _values(rules) {
  var ret = {};

  var values = _getRuleValues(rules);

  for (var name in rules) {
    var itemValue = _getItemValue(rules[name], values, true);

    ret[name] = itemValue;
  }

  return ret;
};

var _default2 = _validate;
exports.default = _default2;
module.exports = exports.default;